import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { ClassNameMap } from '@mui/styles';

const useStyles = makeStyles(() => ({
  root: {
    top: 0,
    left: 0,
    position: 'sticky',
    zIndex: 30
  }
}));

type DrawerHeaderProps = { classes?: ClassNameMap; children?: React.ReactNode };

export const DrawerHeader: React.FC<DrawerHeaderProps> = ({
  classes,
  children,
  ...rest
}: DrawerHeaderProps) => {
  const cls = useStyles({ classes });
  return (
    <div className={cls.root} data-testid="drawer-header" {...rest}>
      {children}
    </div>
  );
};
